module.exports = __webpack_public_path__ + "static/media/profile_icon.180077d4.svg";